import React, { Component } from "react";
import { Row, Col, Collapse } from "reactstrap";
import { Link, withRouter } from "react-router-dom";
import classname from "classnames";
import MetisMenu from "metismenujs";
import SimpleBar from "simplebar-react";

import {checkRoleMenu} from "../config/Utils";

class Menu extends Component {
	constructor(props) {
        super(props);
        this.state = {
            isReady:false,
            menuPendaftaran:false,
            menuDataArsip:false,
            menuLaporan:false,
            menuMaster:false,
            menuSaksi:false,
            menuApproval:false,
            menuVerifikasiAktif:false,
            menuJra:false,
        };
    }

    initMenu() {
        new MetisMenu("#side-menu");

        var matchingMenuItem = null;
        var ul = document.getElementById("side-menu");
        var items = ul.getElementsByTagName("a");
        /*for (var i = 0; i < items.length; ++i) {
            if (this.props.location.pathname === items[i].pathname) {
                matchingMenuItem = items[i];
                break;
            }
        }
        if (matchingMenuItem) {
            this.activateParentDropdown(matchingMenuItem);
        }*/
    }

    componentDidMount() {
        this.initMenu();
    }

    componentDidUpdate(prevProps) {
        if (this.props.type !== prevProps.type) {
            this.initMenu();
        }
    }

    activateParentDropdown = item => {
        item.classList.add("active");
        const parent = item.parentElement;

        if (parent) {
            parent.classList.add("mm-active");
            const parent2 = parent.parentElement;

            if (parent2) {
                parent2.classList.add("mm-show");

                const parent3 = parent2.parentElement;

                if (parent3) {
                    parent3.classList.add("mm-active"); // li
                    parent3.childNodes[0].classList.add("mm-active"); //a
                    const parent4 = parent3.parentElement;
                    if (parent4) {
                        parent4.classList.add("mm-active");
                    }
                }
            }
            return false;
        }
        return false;
    };

    render() {
        if(!this.state.isReady){
            this.setState({
                isReady:true
            });

            //check notif tiap 1 menit
            var me =this;
           /* setInterval(function() {
                me.props.parentLoadNotif();
            }, 30 * 1000);
            me.props.parentLoadNotif();*/

            

            
            //console.log(aa.some(item => item.id_hak_akses_user === 5));
            //aa.map((rec,index)=>{
             //   console.log(rec);
            //})
            //console.log(aa.includes('3'));
            //if()
        }
    	return (
    		<React.Fragment>
                <div className="vertical-menu">
                    <div data-simplebar className="h-100">
                        <SimpleBar style={{ maxHeight: "100%" }}>
                        <div id="sidebar-menu">
                            <ul className="metismenu list-unstyled" id="side-menu">
                                <li>
                                    <Link to="/dashboard" className="waves-effect">
                                        <i className="fas fa-desktop mr-2"></i>
                                        <span>{'Dashboard'}</span>
                                    </Link>
                                </li>
                                <li className="menu-title">{'PRODUCT'}</li>
                                <li>
                                    <Link to="/product-office" className="waves-effect">
                                            <i className="fas fa-cubes"></i>
                                            <span>{'Product Office'}</span>
                                    </Link>
                                </li>
                               
                                <li className="menu-title">{'REPORT'}</li>
                                <li>
                                    <Link to="/report-product-history" className="waves-effect">
                                            <i className="fas fa-cubes"></i>
                                            <span>{'Product History'}</span>
                                    </Link>
                                </li>

                                <li className="menu-title">{'MASTER'}</li>
                                <li>
                                    <Link to="/user" className="waves-effect">
                                        <i className="fas fa-user"></i>
                                        <span>{'User'}</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/client" className="waves-effect">
                                        <i className="fas fa-handshake"></i>
                                        <span>{'Client'}</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/supplier" className="waves-effect">
                                        <i className="fas fa-users"></i>
                                        <span>{'Supplier'}</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/unit" className="waves-effect">
                                        <i className="fas fa-clone"></i>
                                        <span>{'Unit'}</span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        </SimpleBar>
                    </div>
                </div>
    		</React.Fragment>
    	)
    }

}

export default Menu;